export default "__VITE_ASSET__9c57fa0e__"